import { Box, Heading, Spacer, Stack, useBreakpointValue } from '@chakra-ui/react'

import { BLOG_ABOUT_ARTICLE_SLUG } from '@/client/services/blog'
import { getBlogCategoryUrl, getBlogUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Tabs from '@/components/Tabs/Tabs'
import ShwLogo from '@/components/UI/ShwLogo'

type BlogTab = 'All' | 'Community' | 'HQ' | 'Updates' | 'About'

const TAB_TO_URL = {
  All: getBlogUrl(),
  Community: getBlogCategoryUrl('community'),
  HQ: getBlogCategoryUrl('hq'),
  Updates: getBlogCategoryUrl('updates'),
  About: getBlogUrl(BLOG_ABOUT_ARTICLE_SLUG),
}

export default function BlogHeader({
  currentTab,
}: {
  currentTab: BlogTab | null
}): React.ReactElement {
  const hideBorder = useBreakpointValue({ base: false, md: true })
  const hideTabBorder = useBreakpointValue({ base: false, md: true })

  return (
    <Stack direction="column" spacing="8px" mb="48px">
      <Stack
        direction={{ base: 'column', md: 'row' }}
        align={{ base: 'flex-start', md: 'center' }}
        spacing="16px"
        width="100%"
      >
        <ShwLink href={getBlogUrl()}>
          <Stack direction="row" align="center" spacing="8px">
            <ShwLogo width="20px" />
            <Box borderRight="2px solid" borderRightColor="primary.solid" height="24px" />
            <Heading size="2xl" pb="2px" color="fg">
              Blog
            </Heading>
          </Stack>
        </ShwLink>
        <Spacer />
        <Box width="100%" display={{ base: 'none', md: 'block' }}>
          <Tabs<BlogTab>
            variant="normal"
            currentTab={currentTab}
            activeTextColor="primary.fg"
            tabToUrl={t => TAB_TO_URL[t]}
            tabs={['All', 'Community', 'HQ', 'Updates', 'About']}
            hideBorder={hideBorder}
            hideTabBorder={hideTabBorder}
            buttonProps={{ px: '8px' }}
          />
        </Box>
        <Box width="100%" display={{ base: 'block', md: 'none' }}>
          <Tabs<BlogTab>
            variant="normal"
            currentTab={currentTab}
            tabToUrl={t => TAB_TO_URL[t]}
            tabs={['All', 'Community', 'HQ', 'Updates', 'About']}
            buttonProps={{ px: '8px' }}
          />
        </Box>
      </Stack>
    </Stack>
  )
}
